
export enum ResultItemType {
  VOLCANO,
  SEARCH,
}
